import HomeNavbar from './HomeNavbar'
import PageNavbar from './PageNavbar'
import { useTranslation } from 'react-i18next'

const Navbar = ({
  client,
  sites,
  activeSite,
  setActiveSite,
  sidebarToggler
}) => {
  const { t } = useTranslation()
  const [, root, detail] = window.location.pathname.split('/')

  if (root === 'profile') return <PageNavbar title={t('Profile')} home />
  if (root === 'notifications') return <PageNavbar title={t('Notifications')} />
  if (root === 'setting') return <PageNavbar title={t('Settings')} />
  if (root === 'changePassword') return <PageNavbar title={t('Change Password')} />
  if (root === 'upload-proof') return <PageNavbar title="Upload proof" />
  if (root === 'communications' && detail === 'instructions') {
    return <PageNavbar title="Communication" />
  }
  return (
    <HomeNavbar
      client={client}
      sites={sites}
      activeSite={activeSite}
      setActiveSite={setActiveSite}
      sidebarToggler={sidebarToggler}
    />
  )
}

export default Navbar
